import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Collapse,
  Avatar,
} from "@mui/material";
import Swal from "sweetalert2";

const AccepetHolidayTL = () => {
  const [employees, setEmployees] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);

  const currentUser = JSON.parse(localStorage.getItem("data"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [employeesRes, leavesRes] = await Promise.all([
          axios.get(
            "https://backenderpforseg.samielmetwali.com/getemployees.php"
          ),
          axios.get(
            "https://backenderpforseg.samielmetwali.com/getleaveRequest.php"
          ),
        ]);

        if (employeesRes.data.status === "success" && leavesRes.data.success) {
          const allEmployees = employeesRes.data.data;
          let allLeaves = leavesRes.data.data;

          setEmployees(allEmployees);

          const teamEmployees = allEmployees.filter(
            (emp) =>
              emp.department2?.toLowerCase() ===
              currentUser.department2?.toLowerCase()
          );

          // إذا كان الموظف قائد فريق، عدل head_accepted = 1
          allLeaves = allLeaves.map((leave) => {
            const emp = allEmployees.find(
              (e) => e.username?.toLowerCase() === leave.username?.toLowerCase()
            );
            if (emp && emp.position === "قائد فريق") {
              return { ...leave, head_accepted: 1 };
            }
            return leave;
          });

          const teamLeaves = allLeaves.filter((leave) =>
            teamEmployees.some(
              (emp) =>
                emp.username?.toLowerCase() === leave.username?.toLowerCase()
            )
          );

          setLeaves(teamLeaves);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getEmployeeDetails = (username) =>
    employees.find((emp) => emp.username === username) || {};

  const handleApprove = async (id) => {
    try {
      const res = await axios.post(
        "https://backenderpforseg.samielmetwali.com/updateLeaveRequest.php",
        { id, head_accepted: 1 }
      );
      if (res.data.success) {
        Swal.fire("تم التصديق", "", "success");
        setLeaves((prev) =>
          prev.map((l) => (l.id === id ? { ...l, head_accepted: 1 } : l))
        );
      }
    } catch {
      Swal.fire("فشل التصديق", "", "error");
    }
  };

  const handleReject = async (id) => {
    try {
      const res = await axios.post(
        "https://backenderpforseg.samielmetwali.com/updateLeaveRequest.php",
        { id, head_accepted: 0 }
      );
      if (res.data.success) {
        Swal.fire("تم الرفض", "", "success");
        setLeaves((prev) =>
          prev.map((l) => (l.id === id ? { ...l, head_accepted: 0 } : l))
        );
      }
    } catch {
      Swal.fire("فشل الرفض", "", "error");
    }
  };

  const getRowStyle = (head_accepted) => {
    if (head_accepted === 1)
      return { backgroundColor: "#243a26", color: "white" };
    if (head_accepted === 0)
      return { backgroundColor: "#4a2a2a", color: "white" };
    return { backgroundColor: "#1f1f1f", color: "white" };
  };

  const toggleExpand = (index) => {
    setExpandedRow((prev) => (prev === index ? null : index));
  };

  if (loading) return <Typography>جاري التحميل...</Typography>;

  if (
    !currentUser ||
    !["قائد فريق", "رئيس"].includes((currentUser.position || "").trim())
  ) {
    return <Typography>ليس لديك صلاحية الوصول لهذه الصفحة</Typography>;
  }

  return (
    <Box
      p={2}
      style={{
        fontFamily: "Cairo, sans-serif",
        direction: "rtl",
        backgroundColor: "#141718",
        color: "white",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h5" gutterBottom style={{ color: "#6fd943" }}>
        طلبات إجازات فريقك
      </Typography>
      <Paper
        style={{ padding: 16, backgroundColor: "#1f2224", color: "white" }}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  الصورة
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  اسم الموظف
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  القسم
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  السبب
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  تاريخ البدء
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  تاريخ الانتهاء
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  الإجراءات
                </TableCell>
                <TableCell align="right" style={{ color: "#6fd943" }}>
                  تفاصيل
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaves.filter((leave) => {
                const emp = getEmployeeDetails(leave.username);
                const position = (emp.position || "").trim();
                return position !== "قائد فريق" && position !== "رئيس";
              }).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    لا يوجد بيانات لعرضها
                  </TableCell>
                </TableRow>
              ) : (
                leaves
                  .filter((leave) => {
                    const emp = getEmployeeDetails(leave.username);
                    const position = (emp.position || "").trim();
                    return position !== "قائد فريق" && position !== "رئيس";
                  })
                  .map((leave, index) => {
                    const emp = getEmployeeDetails(leave.username);
                    return (
                      <React.Fragment key={leave.id}>
                        <TableRow style={getRowStyle(leave.head_accepted)}>
                          <TableCell align="right">
                            <Avatar
                              src={`https://backenderpforseg.samielmetwali.com/${emp.photo}`}
                              alt={emp.name}
                            />
                          </TableCell>
                          <TableCell align="right">{emp.name}</TableCell>
                          <TableCell align="right">{emp.department2}</TableCell>
                          <TableCell align="right">
                            {leave.leave_reason}
                          </TableCell>
                          <TableCell align="right">
                            {leave.start_date}
                          </TableCell>
                          <TableCell align="right">{leave.end_date}</TableCell>
                          <TableCell align="right">
                            {leave.head_accepted === null ? (
                              <>
                                <Button
                                  onClick={() => handleApprove(leave.id)}
                                  style={{
                                    margin: "2px",
                                    backgroundColor: "#6fd943",
                                    color: "#141718",
                                  }}
                                >
                                  تصديق
                                </Button>
                                <Button
                                  onClick={() => handleReject(leave.id)}
                                  style={{
                                    margin: "2px",
                                    backgroundColor: "#f04e4e",
                                    color: "#fff",
                                  }}
                                >
                                  رفض
                                </Button>
                              </>
                            ) : (
                              <Typography>
                                {leave.head_accepted === 1
                                  ? "تم القبول"
                                  : "تم الرفض"}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="right">
                            <Button
                              onClick={() => toggleExpand(index)}
                              style={{
                                backgroundColor: "#6fd943",
                                color: "#141718",
                              }}
                            >
                              {expandedRow === index ? "إخفاء" : "تفاصيل"}
                            </Button>
                          </TableCell>
                        </TableRow>
                        {expandedRow === index && (
                          <TableRow>
                            <TableCell colSpan={8}>
                              <Collapse in={true}>
                                <Box p={2}>
                                  <Typography>
                                    <strong>الموظف:</strong> {emp.name}
                                    <br />
                                    <strong>القسم:</strong> {emp.department2}
                                    <br />
                                    <strong>السبب:</strong> {leave.leave_reason}
                                    <br />
                                    <strong>الفترة:</strong> {leave.start_date}{" "}
                                    إلى {leave.end_date}
                                  </Typography>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default AccepetHolidayTL;
